import * as z from "zod";

// The dispute-alert networks, as the wire contract for this RPC. Defined inline
// rather than imported from the integrations DB schema so the (web-shared) SDK
// doesn't pull in a server-only Mongoose package; mirrors the parallel unions in
// the Disputely HTTP client and DB schema (see DisputelyAlertNetwork there).
export const disputelyAlertNetworkSchema = z.enum(["CDRN", "ETHOCA", "RDR"]);

// Merchant-confirmed inputs: descriptors for CDRN/ETHOCA; arns for RDR (Disputely
// resolves ARNs to BIN/CAID on its side). The server validates that the
// network's required inputs are present.
export const enrollDisputelyAlerts = {
  name: "enrollDisputelyAlerts" as const,
  input: z.object({
    network: disputelyAlertNetworkSchema,
    descriptors: z.array(z.string()).optional(),
    arns: z.array(z.string()).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    status: z.enum(["enrolled", "failed"]).optional(),
    // How a success landed: fresh enroll, add to an existing integration, or
    // the requested state already held (benign 409). Drives the toast copy.
    mode: z.enum(["enrolled", "added", "already_present"]).optional(),
    error: z.string().optional(),
  }),
};
